import { createThunklessAction } from 'thunkless';

import { avo } from '@/api/app/avo-client';

export enum OfficeHoursTypes {
  FETCH_OFFICE_HOURS_DATA_REQUEST = 'app/office_hours/FETCH_OFFICE_HOURS_DATA_REQUEST',
  FETCH_OFFICE_HOURS_DATA_SUCCESS = 'app/office_hours/FETCH_OFFICE_HOURS_DATA_SUCCESS',
  FETCH_OFFICE_HOURS_DATA_FAILURE = 'app/office_hours/FETCH_OFFICE_HOURS_DATA_FAILURE',

  CREATE_EXCEPTION_REQUEST = 'app/office_hours/CREATE_EXCEPTION_REQUEST',
  CREATE_EXCEPTION_SUCCESS = 'app/office_hours/CREATE_EXCEPTION_SUCCESS',
  CREATE_EXCEPTION_FAILURE = 'app/office_hours/CREATE_EXCEPTION_FAILURE',

  DESTROY_EXCEPTION_REQUEST = 'app/office_hours/DESTROY_EXCEPTION_REQUEST',
  DESTROY_EXCEPTION_SUCCESS = 'app/office_hours/DESTROY_EXCEPTION_SUCCESS',
  DESTROY_EXCEPTION_FAILURE = 'app/office_hours/DESTROY_EXCEPTION_FAILURE',

  CLEAR_CREATE_EXCEPTION_ERROR = 'app/office_hours/CLEAR_CREATE_EXCEPTION_ERROR',
}

export const clearCreateExceptionError = () => ({
  type: OfficeHoursTypes.CLEAR_CREATE_EXCEPTION_ERROR as const,
});

export interface FetchOfficeHoursDataProps {
  subdomain: string;
}

export const fetchOfficeHoursData = ({
  subdomain,
}: FetchOfficeHoursDataProps) => createThunklessAction({
  type: [
    OfficeHoursTypes.FETCH_OFFICE_HOURS_DATA_REQUEST,
    OfficeHoursTypes.FETCH_OFFICE_HOURS_DATA_SUCCESS,
    OfficeHoursTypes.FETCH_OFFICE_HOURS_DATA_FAILURE,
  ] as const,
  promise: () => avo.ajax({
    method: 'GET',
    route: `/accounts/${subdomain}/office_hours_data`,
  }),
});

export interface CreateOfficeHourExceptionProps {
  subdomain: string;
  exceptionDate: string;
  label: string;
}

export const createOfficeHourException = ({
  subdomain, exceptionDate, label,
}: CreateOfficeHourExceptionProps) => createThunklessAction({
  type: [
    OfficeHoursTypes.CREATE_EXCEPTION_REQUEST,
    OfficeHoursTypes.CREATE_EXCEPTION_SUCCESS,
    OfficeHoursTypes.CREATE_EXCEPTION_FAILURE,
  ] as const,
  // retries: 0 — mutations shouldn't silently retry. 422 validation errors
  // aren't in avo.ajax's retry whitelist, so without this the user would wait
  // ~7s (default 2 retries with exponential backoff) before the error surfaces.
  promise: () => avo.ajax({
    method: 'POST',
    route: `/accounts/${subdomain}/office_hour_exceptions`,
    payload: { office_hour_exception: { exception_date: exceptionDate, label } },
  }, { retries: 0 }),
});

export interface DestroyOfficeHourExceptionProps {
  subdomain: string;
  id: number;
}

export const destroyOfficeHourException = ({
  subdomain, id,
}: DestroyOfficeHourExceptionProps) => createThunklessAction({
  type: [
    OfficeHoursTypes.DESTROY_EXCEPTION_REQUEST,
    OfficeHoursTypes.DESTROY_EXCEPTION_SUCCESS,
    OfficeHoursTypes.DESTROY_EXCEPTION_FAILURE,
  ] as const,
  promise: () => avo.ajax({
    method: 'DELETE',
    route: `/accounts/${subdomain}/office_hour_exceptions/${id}`,
  }, { retries: 0 }),
  meta: { id },
});
